import React from 'react';
import 'react-bootstrap-datetimepicker/css/bootstrap-datetimepicker.min.css';
import { Link } from 'react-router';
import $ from 'jquery';
import {request} from '../helpers/request';
import {t} from '../helpers/translate'
const config = require('config');
const util = require('util')

class Sources extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      baseUrl: '',
      sources: [],
      requestStatus: true
    };
  }

  componentWillMount() {
    this.loadData();
  }

  loadData() {
    $.when(request(`${config.default.api}/sources/`, 'GET', null, this.loadSources.bind(this))).done(this.updateRequestStatus.bind(this));
  }

  loadSources(responseData, statusCode) {
    if (statusCode == 200) {

      this.setState({
        sources: responseData.sources
      });
      return responseData.sources;
    }
  }

  updateRequestStatus (){
    this.setState({requestStatus: false})
  }

  getSourcesData() {
  
    /*
    this.loadData();
  
    return this.state.sources.length > 0 ?
    this.state.sources
    :
    []
    //*/
  
    return [
      {
        value:'7fe37f6e-f50e-4e4d-a771-36bd5e9144fc',
        text: 'Association All Inclusive Travel Insurance'
      },
      {
        value:'061db65a-e921-455a-a469-a492ae6cd771',
        text: 'Association Non-Medical Travel Insurance'
      }
    ]

  } 
}

Sources.defaultProps = {};

export default Sources;



// WEBPACK FOOTER //
// ./src/helpers/sources.js